import axios from 'axios';

const defaultHost = typeof window !== 'undefined' && window.location && window.location.hostname
  ? window.location.hostname
  : 'localhost';

const baseHost = process.env.REACT_APP_API_URL || `http://${defaultHost}:8080`;

// 配置全局axios默认设置
axios.defaults.baseURL = baseHost + (process.env.REACT_APP_API_REQ_PATH || '');
axios.defaults.timeout = 180000;

// 请求拦截器 - 添加认证token
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    // 对于multipart/form-data请求，不设置Content-Type，让浏览器自动设置
    if (!config.headers['Content-Type'] || config.headers['Content-Type'] === 'multipart/form-data') {
      delete config.headers['Content-Type'];
    } else if (!config.headers['Content-Type']) {
      config.headers['Content-Type'] = 'application/json';
    }
    
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理401错误
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // 401未授权错误，清除本地存储的认证信息
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      delete axios.defaults.headers.common['Authorization'];
      
      const isManualLogout = typeof window !== 'undefined' && window.didManualLogout;
      if (isManualLogout) {
        window.didManualLogout = false;
        return Promise.reject(error);
      }

      // 设置一个标志，避免重复处理
      if (!window.isHandling401) {
        window.isHandling401 = true;
        
        // 显示登录过期提示
        import('react-hot-toast').then(({ default: toast }) => {
          toast.error('登录已过期，请重新登录', {
            duration: 4000,
            position: 'top-center',
          });
        });
        
        // 直接跳转到登录页面，使用replace避免用户通过后退按钮回到需要认证的页面
        setTimeout(() => {
          window.location.replace('/login');
        }, 100); // 短暂延迟确保toast显示
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
